import React, { useState, useEffect } from 'react';
import Heading from '../../components/Heading/Heading';
import NavBar from '../../components/NavBar/NavBar';
import { useNavigate } from 'react-router-dom';
import PaymentModal from '../PaymentModel/PaymentModal';
import { t } from 'localizify';
import { payScript } from '../Common/CommonFunctions';
import Swal from 'sweetalert2';
import { addCredit, generateSessionToken } from '../../api/apiHandler';

const AddToWallet = ({ isLoader }) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        amount: '',
        tags: '',
        notes: ''
    });
    const donor_data = JSON.parse(localStorage.getItem('DAData'));
    const [paymentModalIsOpen, setPaymentModalIsOpen] = useState(false);
    const [token, setToken] = useState(null);
    const [card, setCard] = useState(null);
    const [exp, setExp] = useState(null);
    const [cvv, setCvv] = useState(null);
    const [name, setName] = useState('');
    const [lastname, setLastname] = useState('');
    const [txnStatus, setTxnStatus] = useState('');
    const [txnResponse, setTxnResponse] = useState('');

    const fireSwal = (message, type) => {
        Swal.fire("Food For Good", message, type);
    };
    const splitFullName = (fullName) => {
        if (!fullName || typeof fullName !== 'string') {
            return { firstName: '', lastName: '' };
        }
        const parts = fullName.trim().split(' ');
        const firstName = parts.shift();
        const lastName = parts.join(' ');
        return { firstName, lastName };
    };

    useEffect(() => {
            if (token) {
                pay();
            }
        }, [token]);
    useEffect(() => {
        // Load Converge Payment script dynamically
        const script = document.createElement("script");
        script.src = payScript
        script.async = true;
        document.body.appendChild(script);
    
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        if (donor_data?.full_name) {
            const { firstName, lastName } = splitFullName(donor_data.full_name);
            setName(firstName);
            setLastname(lastName);
        }
    }, [donor_data]);
    const totalAmount = formData.amount;
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const initiateCheckoutJS = async () => {
        isLoader(true);
        setPaymentModalIsOpen(false);
        const data = {
            amount: formData.amount,
            first_name: name,
            last_name: lastname
        };
        try {
            const response = await generateSessionToken(data);
            if (response.data.code == 1) {
                setToken(response.data.data);
            } else {
                fireSwal(
                    `can't generate session token <br />${response.data.message}`,
                    "error"
                );
                isLoader(false);
            }
        } catch (error) {
            console.error("Error fetching token:", error);
        }
    }
    const checkOrderSummary = () => {
        initiateCheckoutJS();
    };

  const callAPIAddCredit = async (transactionId) => {
    isLoader(true);
    const data = {
        donor_id: donor_data?.id,
        wallet_id: donor_data?.wallet_id,
        amount: Number(formData.amount),
        tags: formData.tags ? formData.tags.split(',').map(t => t.trim()) : [],
        notes: formData.notes,
        transaction_id: transactionId
    };
    try {
        const res = await addCredit(data);
        if (res.data.code == 1) {
            isLoader(false);
            Swal.fire({
                title: "Food For Good",
                text: "Credit added successfully.",
                confirmButtonText: 'Okay'
            });
            navigate('/wallet-controls');
        } else {
            isLoader(false);
            Swal.fire(
                'Food For Good',
                "Data Not Found",
                'error'
            )
        }
    } catch (error) {
        isLoader(false);
        Swal.fire('Food For Good', error.message || 'Something went wrong', 'error');
    }
  }

  const pay = () => {
        const paymentData = {
            ssl_txn_auth_token: token,
            ssl_card_number: card,
            ssl_exp_date: exp,
            ssl_cvv2cvc2: cvv,
            ssl_get_token: 'Y',
            ssl_add_token: 'Y',
            ssl_invoice_number: 'INV123',
            ssl_first_name: name,
            ssl_last_name: lastname
        };
        const callback = {
            onError: (error) => {
                showResult('error', error);
                fireSwal(error, 'error');
            },
            onDeclined: (response) => {
                console.log('Result Message=' + response['ssl_result_message']);
                showResult('declined', JSON.stringify(response));
                fireSwal(JSON.stringify(response), 'error');
            },
            onApproval: async (response) => {
                console.log('Approval Code=' + response['ssl_approval_code']);
                showResult('approval', JSON.stringify(response));
                const transID = response?.ssl_txn_id
                try {
                    callAPIAddCredit(transID);
                } catch (error) {
                    console.error('Transaction error:', error);
                    fireSwal('An error occurred while processing your payment', 'error');
                }
            }

        }
        // Make sure ConvergeEmbeddedPayment is available before calling pay
        if (window.ConvergeEmbeddedPayment) {
            console.log('ConvergeEmbeddedPayment is loaded')
            window.ConvergeEmbeddedPayment.pay(paymentData, callback);
        } else {
            console.error('ConvergeEmbeddedPayment is not loaded');
        }
        return false;
    };
      const showResult = (status, msg) => {
        setTxnStatus(<b>{status}</b>);
        setTxnResponse(msg);
    };

  const handlePayNow = () => {
    if (!formData.amount) {
      Swal.fire('Food For Good', 'Please fill in all required fields (Owner ID, Owner Type, Amount).', 'warning');
      return;
    }
    setPaymentModalIsOpen(true);
  };
    return (
        <>
            <NavBar />
            <section className="content home">
                <Heading title="Add Credits" />
                <div className="container-fluid">
                    <div className="row clearfix">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="card" >
                        <div className="body p-4">
                            <div className="col-12 text-left mb-3">
                            <a
                                onClick={() => navigate(-1)}
                                className="btn btn-raised waves-effect waves-float waves-red text-left mr-2"
                            >
                                <i className="zmdi zmdi-arrow-left"  />
                            </a>
                            </div>
                            <hr />
                            <div className="card  mb-0">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                <div className="about-info-p">
                                    <strong >Amount</strong>
                                    <input
                                    type="number"
                                    name="amount"
                                    className="form-control p-4 mt-2"
                                    value={formData.amount}
                                    onChange={handleInputChange}
                                    placeholder="Enter Amount"
                                    style={{
                                        border: "2px solid #dee2e6",
                                        borderRadius: "8px",
                                    }}
                                    />
                                </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 ">
                                <div className="about-info-p">
                                    <strong >Short Notes</strong>
                                    <textarea
                                    name="notes"
                                    rows="5"
                                    className="form-control no-resize p-4 mt-2 "
                                    value={formData.notes}
                                    onChange={handleInputChange}
                                    placeholder="Please type what you want..."
                                    style={{
                                        border: "2px solid #dee2e6",
                                        borderRadius: "8px"
                                    }}
                                    ></textarea>
                                </div>
                                </div>
                            </div>
                            </div>
                            <div className="text-center mb-2 mt-3">
                            <button
                                onClick={handlePayNow}
                                className="btn btn-success btn-round text-capitalize font_20 me-2 px-4 py-3"
                            >
                                Pay Now
                            </button>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </section>

            <PaymentModal
                paymentModalIsOpen={paymentModalIsOpen}
                setPaymentModalIsOpen={setPaymentModalIsOpen}
                name={name}
                setName={setName}
                lastname={lastname}
                setLastname={setLastname}
                token={token}
                card={card}
                setCard={setCard}
                exp={exp}
                setExp={setExp}
                cvv={cvv}
                setCvv={setCvv}
                totalAmount={totalAmount}
                txnStatus={txnStatus}
                txnResponse={txnResponse}
                checkOrderSummary={checkOrderSummary}
                pay={pay}
            />
        </>
    );
};

export default AddToWallet;
